<template>
  <scout-form
    :is-modified="!!value.length"
    label="転職意欲"
  >
    <div
      v-for="option in changeJobsMotivationsMaster"
      :key="option.id"
      class="boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap"
    >
      <label
        :data-test="`label-${option.id}`"
        class="boss-checkbox"
      >
        <input
          :value="option.id"
          :checked="value.includes(option.id)"
          :data-test="`checkbox-${option.id}`"
          type="checkbox"
          class="boss-input-checkbox"
          @change="onChange"
        >{{ option.name }}
      </label>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'changeJobsMotivationsMaster'
    ])
  },
  methods: {
    onChange ($event) {
      if ($event.target.checked) {
        this.$emit('input', [...this.value, $event.target._value])
      } else {
        this.$emit('input', _.without(this.value, $event.target._value))
      }
    }
  }
}
</script>
